export default __webpack_public_path__ + "static/media/16.7b054c6b.png";